module.exports = __webpack_public_path__ + "static/media/logo-mobile.ec4d8608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/black-weekend/logo-mobile.png
// module id = 1456
// module chunks = 0